import { render, staticRenderFns } from "./photo.vue?vue&type=template&id=73293b9e&scoped=true&lang=html&"
import script from "./photo.vue?vue&type=script&lang=js&"
export * from "./photo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73293b9e",
  null
  
)

export default component.exports